import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';

import PATH from '@/constants/path';
import useUser from '@/hooks/use-user.hook';

export default function PublicLayout() {
  const { isSignedIn } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSignedIn && window.location.pathname === PATH.INDEX) {
      navigate(PATH.DASHBOARD.INDEX);
    }
    // This comment is to disable the exhaustive-deps rule for this effect, as we only want to run it when isSignedIn changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn]);

  return <Outlet />;
}
